// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"MaintenanceTriggers_tableContainer__1mbOk","triggersTable":"MaintenanceTriggers_triggersTable__I_i87"};